import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useWoody } from '../../woody/woody.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { getIntegrationViewConfig } from '../connections.config.js';
import { integrationsQueryKeys } from './integrationsQueryKeys.js';

const defaultData = [];
const useQueryIntegrations = (options) => {
  const { client } = useWoody();
  const { data: user } = useQueryUserInfo();
  const isLoggedIn = !!user;
  const enabled = isQueryEnabled([
    options?.enabled ?? true,
    isLoggedIn
  ]);
  const query = useQuery({
    queryKey: integrationsQueryKeys.list(),
    queryFn: async () => {
      return await client.v2("/v2/integrations");
    },
    placeholderData: keepPreviousData,
    enabled
  });
  const integrations = useMemo(() => {
    return (query.data?.data.integrations || defaultData).map((item) => ({
      ...item,
      viewConfig: getIntegrationViewConfig(item)
    })).sort((a, b) => a.displayName.localeCompare(b.displayName));
  }, [
    query.data?.data.integrations
  ]);
  return {
    integrations,
    ...query
  };
};

export { useQueryIntegrations };
//# sourceMappingURL=useQueryIntegrations.js.map
